/* amasus custom fit*/
export function registerKendoTheme () {
    kendo.dataviz.ui.registerTheme('customInsa', 
    {   
        "chart": {
            "title": {
                "color": "#686868"
            },
            "legend": {
                "labels": {
                    "color": "#686868"
                }
            },
            "chartArea": {
                "background": "#ffffff"
            },
            "seriesDefaults": {
                "labels": {
                    "color": "#686868"
                },
           "pie": {
             "overlay": {
                 "gradient": "none"
             }
         },
         
         "donut": {
             "overlay": {
                 "gradient": "none"
             }
         },
         "column": {
             "overlay": {
                 "gradient": "none"
             }
         }
            },
            "axisDefaults": {
                "line": {
                    "color": "#9e9e9e"
                },
                "labels": {
                    "color": "#686868"
                },
                "minorGridLines": {
                    "color": "#e7e7e7"
                },
                "majorGridLines": {
                    "color": "#dadada"
                },
                "title": {
                    "color": "#686868"
                }
            },
            "seriesColors": [
                "#9a9839",
                "#77762b",
                "#4e4d1c",
                "#bdbc81",
                "#808080",
                "#464747",
                "#373838",
                "#d2d2d2",
                "#373838",
                "#ac926a",
                "#dda148"
            ]
        },
        "gauge": {
            "pointer": {
                "color": "#454E7E"
            },
            "scale": {
                "rangePlaceholderColor": "#e7e7e7",
                "labels": {
                    "color": "#686868"
                },
                "minorTicks": {
                    "color": "#aaaaaa"
                },
                "majorTicks": {
                    "color": "#888888"
                },
                "line": {
                    "color": "#9e9e9e"
                }
            }
        }
    });    
}



// WEBPACK FOOTER //
// ./insa-css/insa-clients/Amadeus/insa-kendo-css/kendo.custom.dataviz.ts